export const experienceData = [
    {
        id: 1,
        company: 'Avanza Innovations',
        jobtitle: 'AI Engineer',
        startYear: '2025',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Fynder.AI',
        jobtitle: 'Associate AI Engineer',
        startYear: '2024',
        endYear: '2024'
    },
    {
        id: 3,
        company: 'Future Content Company',
        jobtitle: 'Data Science Intern',
        startYear: '2022',
        endYear: '2022'
    },
]